export const scopeTableCols = [
  {
    header: "#",
    accessorFn: (row, rowIndex) => (rowIndex === -1 ? "New" : rowIndex + 1),
    size: 10,
    enableSorting: false,
    enableEditing: false,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Edit: () => <></>,
  },

  {
    accessorKey: "quantity",
    header: "Qty",
    grow: false,
    size: 60,
  },
  {
    accessorKey: "unit",
    header: "Unit",
    grow: false,
    size: 60,
  },
  {
    accessorKey: "description",
    header: "Scope Description",
    grow: false,
    size: 60,
  },
];
